import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Company {
  id: string;
  name: string;
  slug: string;
  ticketHeader?: string;
  ticketFooter?: string;
  allowNegativeStock?: boolean;
}

interface User {
  id: string;
  username: string;
  email: string;
  fullName: string;
  lastLogin?: string | null;
  role: string;
  permissions: string[];
  company: Company;
  branch: { id: string; name: string } | null;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  sessionExpired: boolean;
  setAuth: (user: User, accessToken: string, refreshToken: string) => void;
  setSessionExpired: (expired: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,
      sessionExpired: false,

      setAuth: (user, accessToken, refreshToken) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        set({ user, accessToken, isAuthenticated: true, sessionExpired: false });
      },

      setSessionExpired: (expired) => {
        set({ sessionExpired: expired });
      },

      logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        set({ user: null, accessToken: null, isAuthenticated: false, sessionExpired: false });
      },
    }),
    {
      name: 'pos-auth',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
